import React from 'react';
import './RevenueOptimizationDetail.scss';
import { FiCheckCircle } from 'react-icons/fi';

const RevenueOptimizationDetail = ({ data }) => {
    if (!data) return null;

    return (
        <section className="hsv-revenue-detail-wrapper">
            <div className="layout_container">
                <div className="hsv-revenue-detail-container">
                    {/* Header */}
                    <div className="ecosystem-detail__heading hsv-revenue-detail-header">
                        <div>
                            <span>CHIẾN LƯỢC TÀI CHÍNH</span>
                            <h2 className="hsv-rd-main-title">{data.title}</h2>
                            <p className="hsv-rd-main-subtitle">{data.subtitle}</p>
                        </div>
                    </div>

                    {/* Content Grid */}
                    <div className="hsv-revenue-detail-grid">
                        
                        {/* Left Column - Pillar 0 */}
                        <div className="hsv-rd-col">
                            <div className="hsv-rd-card">
                                <h4 className="hsv-rd-card-title">{data.pillars[0].title}</h4>
                                <ul className="hsv-rd-list">
                                    {data.pillars[0].items.map((item, idx) => (
                                        <li key={idx}><FiCheckCircle className="hsv-rd-icon"/> <span>{item}</span></li>
                                    ))}
                                </ul>
                                
                                <div className="hsv-rd-divider"></div>

                                <h4 className="hsv-rd-card-title hsv-rd-card-title--alt">{data.pillars[0].subTitle}</h4>
                                <ul className="hsv-rd-list">
                                    {data.pillars[0].subItems.map((item, idx) => (
                                        <li key={idx}><FiCheckCircle className="hsv-rd-icon hsv-rd-icon--alt"/> <span>{item}</span></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Middle Column - Pillar 1 */}
                        <div className="hsv-rd-col">
                            <div className="hsv-rd-card">
                                <h4 className="hsv-rd-card-title">{data.pillars[1].title}</h4>
                                <ul className="hsv-rd-list">
                                    {data.pillars[1].items.map((item, idx) => (
                                        <li key={idx}><FiCheckCircle className="hsv-rd-icon"/> <span>{item}</span></li>
                                    ))}
                                </ul>

                                <div className="hsv-rd-divider"></div>

                                <h4 className="hsv-rd-card-title hsv-rd-card-title--alt">{data.pillars[1].subTitle}</h4>
                                <ul className="hsv-rd-list">
                                    {data.pillars[1].subItems.map((item, idx) => (
                                        <li key={idx}><FiCheckCircle className="hsv-rd-icon hsv-rd-icon--alt"/> <span>{item}</span></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Right Column - Diagram */}
                        <div className="hsv-rd-col hsv-rd-col--diagram">
                            <div className="hsv-rd-diagram-wrapper">
                                <div className="hsv-rd-circle-outer">
                                    <span className="hsv-rd-label outer-label">{data.diagram.outer}</span>
                                    
                                    <div className="hsv-rd-circle-middle">
                                        <span className="hsv-rd-label middle-label">{data.diagram.middle}</span>
                                        
                                        <div className="hsv-rd-circle-inner">
                                            <span className="hsv-rd-label inner-label">{data.diagram.center}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Orbiting Elements */}
                                <div className="hsv-rd-orbits-container">
                                    <div className="hsv-rd-orbit-item item-1">{data.diagram.arrows[0]}</div>
                                    <div className="hsv-rd-orbit-item item-2">{data.diagram.arrows[1]}</div>
                                    <div className="hsv-rd-orbit-item item-3">{data.diagram.arrows[2]}</div>
                                    <div className="hsv-rd-orbit-item item-4">{data.diagram.arrows[3]}</div>
                                    <div className="hsv-rd-orbit-item item-5">{data.diagram.arrows[4]}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default RevenueOptimizationDetail;
